import { useAppBack } from '../../hooks/useAppBack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemePicker } from '../../components/ThemePicker';
import { SettingsPageHeader } from './SettingsPageHeader';
import { IoMoonOutline } from 'react-icons/io5';

export function MobileAppearanceSettingsPage() {
  const { t } = useTranslation();
  const goBack = useAppBack('/settings');

  return (
    <div className="mobile-screen mobile-settings-screen">
      <SettingsPageHeader
        title={t('settings.appearance', 'Appearance')}

        icon={IoMoonOutline}
        onBack={goBack}
      />
      <p className="nm-menu-pick-hint">{t('settings.appearanceHint', 'Choose the app theme')}</p>
      <ThemePicker />
    </div>
  );
}
